import { render, staticRenderFns } from "./FieldNumber.vue?vue&type=template&id=700739a8&lang=pug&"
import script from "./FieldNumber.vue?vue&type=script&lang=ts&"
export * from "./FieldNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports